// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_EmptyState_wrapper__37jhZ","extraSpace":"_EmptyState_extraSpace__3lvNR","image":"_EmptyState_image__T6k5b","intro":"_EmptyState_intro__21BlI"};